import { useCallback } from 'react';
import { createTabScopedStore } from './createTabScopedStore';

export type InterceptPanelView = 'queue' | 'rules';

export type InterceptTabFilterState = {
  panelView: InterceptPanelView;
  newRulePattern: string;
  newRuleMethod: string;
};

const useInterceptTabScopedFilterStoreBase =
  createTabScopedStore<InterceptTabFilterState>({
    panelView: 'queue',
    newRulePattern: '',
    newRuleMethod: 'ALL',
  });

export function useTabScopedInterceptFilters() {
  const { filters, update, reset, clearTabScope } =
    useInterceptTabScopedFilterStoreBase();

  const setPanelView = useCallback(
    (panelView: InterceptPanelView) => update({ panelView }),
    [update],
  );
  const setNewRulePattern = useCallback(
    (newRulePattern: string) => update({ newRulePattern }),
    [update],
  );
  const setNewRuleMethod = useCallback(
    (newRuleMethod: string) => update({ newRuleMethod }),
    [update],
  );

  return {
    panelView: filters.panelView,
    newRulePattern: filters.newRulePattern,
    newRuleMethod: filters.newRuleMethod,
    setPanelView,
    setNewRulePattern,
    setNewRuleMethod,
    resetFilters: reset,
    clearTabScope,
  };
}
